import { loadLibrariesWalmeric } from './js/D1C/d1c';
import { obtenerIDVisitante } from './js/functions/obtenerIDVisitante';

document.addEventListener('DOMContentLoaded', function () {
  obtenerIDVisitante()
})

/*Cargamos D1C*/
loadLibrariesWalmeric();